import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  getAllLetterTemplates,
  getLetterTemplates,
  getNoShowLetterTemplates,
} from "app/services/transmission/letter_templates";
import { BASE_URL } from "static/constants";

export const patientProfileDocumentApi = createApi({
  reducerPath: "patientProfileDocumentApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  tagTypes: ["LetterTemplates"],
  endpoints: (builder) => ({
    fetchLetterTemplates: builder.query({
      queryFn: (patientId) => {
        return getLetterTemplates(patientId);
      },
    }),
    fetchAllLetterTemplates: builder.query({
      queryFn: () => {
        return getAllLetterTemplates();
      },
      providesTags: ["LetterTemplates"],
    }),
    fetchNoShowLetters: builder.query({
      queryFn: (patientId) => {
        return getNoShowLetterTemplates(patientId);
      },
    }),
  }),
});

export const {
  useFetchLetterTemplatesQuery,
  useFetchNoShowLettersQuery,
  useFetchAllLetterTemplatesQuery,
} = patientProfileDocumentApi;
